/* tslint:disable */
/* eslint-disable */
/**
 * cellera-backend API spec
 * Backend Service for Cellera | [swagger.json](cellera/swagger.json)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { PricingDetailsDto } from './PricingDetailsDto';
import {
    PricingDetailsDtoFromJSON,
    PricingDetailsDtoFromJSONTyped,
    PricingDetailsDtoToJSON,
    PricingDetailsDtoToJSONTyped,
} from './PricingDetailsDto';

/**
 * 
 * @export
 * @interface CurrentSubscriptionResponseDto
 */
export interface CurrentSubscriptionResponseDto {
    /**
     * Current subscription plan
     * @type {string}
     * @memberof CurrentSubscriptionResponseDto
     */
    plan?: CurrentSubscriptionResponseDtoPlanEnum;
    /**
     * Current subscription status
     * @type {string}
     * @memberof CurrentSubscriptionResponseDto
     */
    status?: string;
    /**
     * Current subscription price details
     * @type {PricingDetailsDto}
     * @memberof CurrentSubscriptionResponseDto
     */
    pricing?: PricingDetailsDto;
    /**
     * Subscription renewal datetime
     * @type {Date}
     * @memberof CurrentSubscriptionResponseDto
     */
    renewalDateTime?: Date;
    /**
     * Subscription start date
     * @type {Date}
     * @memberof CurrentSubscriptionResponseDto
     */
    startDate?: Date;
    /**
     * Subscription end date (if applicable)
     * @type {Date}
     * @memberof CurrentSubscriptionResponseDto
     */
    endDate?: Date;
    /**
     * Whether the subscription will cancel at period end
     * @type {boolean}
     * @memberof CurrentSubscriptionResponseDto
     */
    cancelAtPeriodEnd: boolean;
    /**
     * Is the practice has white glove onboarding
     * @type {boolean}
     * @memberof CurrentSubscriptionResponseDto
     */
    isWhiteGloveOnboarding: boolean;
}


/**
 * @export
 */
export const CurrentSubscriptionResponseDtoPlanEnum = {
    Monthly: 'monthly',
    SixMonths: 'six_months'
} as const;
export type CurrentSubscriptionResponseDtoPlanEnum = typeof CurrentSubscriptionResponseDtoPlanEnum[keyof typeof CurrentSubscriptionResponseDtoPlanEnum];


/**
 * Check if a given object implements the CurrentSubscriptionResponseDto interface.
 */
export function instanceOfCurrentSubscriptionResponseDto(value: object): value is CurrentSubscriptionResponseDto {
    if (!('cancelAtPeriodEnd' in value) || value['cancelAtPeriodEnd'] === undefined) return false;
    if (!('isWhiteGloveOnboarding' in value) || value['isWhiteGloveOnboarding'] === undefined) return false;
    return true;
}

export function CurrentSubscriptionResponseDtoFromJSON(json: any): CurrentSubscriptionResponseDto {
    return CurrentSubscriptionResponseDtoFromJSONTyped(json, false);
}

export function CurrentSubscriptionResponseDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): CurrentSubscriptionResponseDto {
    if (json == null) {
        return json;
    }
    return {
        
        'plan': json['plan'] == null ? undefined : json['plan'],
        'status': json['status'] == null ? undefined : json['status'],
        'pricing': json['pricing'] == null ? undefined : PricingDetailsDtoFromJSON(json['pricing']),
        'renewalDateTime': json['renewalDateTime'] == null ? undefined : (new Date(json['renewalDateTime'])),
        'startDate': json['startDate'] == null ? undefined : (new Date(json['startDate'])),
        'endDate': json['endDate'] == null ? undefined : (new Date(json['endDate'])),
        'cancelAtPeriodEnd': json['cancelAtPeriodEnd'],
        'isWhiteGloveOnboarding': json['isWhiteGloveOnboarding'],
    };
}

export function CurrentSubscriptionResponseDtoToJSON(json: any): CurrentSubscriptionResponseDto {
    return CurrentSubscriptionResponseDtoToJSONTyped(json, false);
}

export function CurrentSubscriptionResponseDtoToJSONTyped(value?: CurrentSubscriptionResponseDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'plan': value['plan'],
        'status': value['status'],
        'pricing': PricingDetailsDtoToJSON(value['pricing']),
        'renewalDateTime': value['renewalDateTime'] == null ? undefined : ((value['renewalDateTime']).toISOString()),
        'startDate': value['startDate'] == null ? undefined : ((value['startDate']).toISOString()),
        'endDate': value['endDate'] == null ? undefined : ((value['endDate']).toISOString()),
        'cancelAtPeriodEnd': value['cancelAtPeriodEnd'],
        'isWhiteGloveOnboarding': value['isWhiteGloveOnboarding'],
    };
}

